'use strict';

/* globals Modernizr */

const _ = require('lodash');

const AdminLoginFormController = function (sbAuth, IntercomService, LoginService) {

  const vm = this;
  vm.error = '';
  vm.inputs = ['email', 'password', 'loginAs'];
  vm.isTouch = typeof Modernizr !== 'undefined' && Modernizr.touch;
  vm.loginButtonText = 'Log in';
  vm.menuActive = false;
  vm.data = {
    email: '',
    loginAs: '',
    password: '',
    rememberme: false
  };

  const onAuthSuccess = (payload) => {

    payload.data.user.adminSession = true;
    LoginService.authSuccess(payload);
  };

  const onAuthError = (res) => {

    vm.loginButtonText = 'Log in';

    if (res.data.error.message === 'NotFoundError') {
      vm.text = 'That user does not exist';
    }
    else {
      vm.text = 'Invalid username or password';
    }

    vm.error = res.data.error;
  };

  vm.login =  _.debounce(() => {

    vm.loginButtonText = 'Loading...';
    sbAuth.authenticate(vm.data, onAuthSuccess, onAuthError);
  }, 50);

  vm.openChat = () => {

    IntercomService.show();
  };

  vm.toggleMenu = () => {

    vm.menuActive = !vm.menuActive;
  };
};

module.exports = AdminLoginFormController;



// WEBPACK FOOTER //
// ./src/app/login/adminLoginForm/AdminLoginFormController.js